import * as types from "./mutation_types"

export default {
    [types.RESET](state){
        Object.assign(state,{
            isLoading: false,
            update: {},
            isUpdated:false,
            showMessage: false,
            message: "",
            isSuccess: false,
            currentItem: null,
            reloadConversation:false,
    
        })
    },
    [types.SET_RELOAD_CONVERSATION](state,reloadConversation){
        Object.assign(state,{reloadConversation})
    },
    [types.SET_TOGGLE_LOADING](state){
        Object.assign(state,{isLoading:!state.isLoading})
    },
    [types.SET_SHOW_LOADING](state){
        Object.assign(state,{isLoading:true})
    },
    [types.SET_HIDE_LOADING](state){
        Object.assign(state,{isLoading:false})
    },
    [types.SET_TOGGLE_MESSAGE](state){
        Object.assign(state,{showMessage:!state.showMessage})
    },
    [types.SET_SHOW_MESSAGE](state){
        Object.assign(state,{showMessage:true})
    },
    [types.SET_HIDE_MESSAGE](state){
        Object.assign(state,{showMessage:false})
    },
    [types.SET_IS_SUCCESS](state){
        Object.assign(state,{isSuccess:true})
    },
    [types.SET_IS_ERROR](state){
        Object.assign(state,{isSuccess:false})
    },
    [types.SET_MESSAGE](state,message){
        Object.assign(state,{message})
    },
    [types.SET_UPDATE](state,update){
        Object.assign(state,{update})
    },
    [types.SET_IS_UPDATED](state){
        Object.assign(state,{isUpdated:true})
    },
    [types.SET_NOT_UPDATED](state){
        Object.assign(state,{isUpdated:false})
    },
    
    [types.SET_CURRENT_ITEM](state,currentItem){
        Object.assign(state,{currentItem})
    },
}